export default "__VITE_ASSET__5c899af5__"